import React from 'react';
import { Link } from 'react-router';
import { RowItemDanhSachThemMoiThanhTra, RowItemThanhTraDeXuat } from 'modules/thanh-tra/datatable';
import { RowItemKetQuaTimKiemThanhTra, DataTableMultipleSelect } from 'modules/thanh-tra/datatable';
import { TextArea, Input, DropDown, InputNumber } from 'components/tt-forms/common';
import { Dialog, Checkbox } from "@blueprintjs/core";
import { Toastr } from 'modules/toastr';
import { ShowIf } from 'components/utils';
import DataTable from 'components/data-table';
import { header } from 'constants/table';
import { ThanhTra, Danhmuc } from 'api';
import { validatable } from 'components/utils';
import classnames from 'classnames';
import {
  DropDownChonLinhVucThanhTraMultiple,
  DropDownMulipleUse
} from 'components/tt-forms';
import { connect } from 'react-redux';
import {
  isEmpty,
  get,
  intersection,
  isArray,
  uniqBy,
  concat,
  union,
  includes,
  isString
} from 'lodash';
import { checkServerLive, LimitFileSize } from 'constants/config';
import { downloadExcel } from "constants/downloadExcel";
import { downloadFile } from 'components/utils';
import { msg } from "constants/message";
import { Reception, DuLieuHeThong } from 'api';
import { API_URL } from 'constants/config';
import { DropDownMultipleSelect } from '../../../tt-forms/common';

class DialogChinhSuaCuocThanhTra extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isOpen: false,
      isOpenDT: false,
      isOpenThongBao: false,
      checkDonViPhoiHop: false,
      namThanhTra: '',
      getTenDoiTuong: [],
      getDSDTDeXuatXuLy: [],
      getDSDTDeXuatXuLys: [],
      idPushCoQuan: [],
      loading: false,
      ketQuaTimKiemList: [],
      nhomDTList: [],
      dataLinhVucThanhTra: [],
      nhomDoiTuongThanhTraId: '',
      hinhThucKHTTList: [],
      chucNangCuocThanhTra: '',
      hinhThucThanhTraChuyenNganh: '',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      linhVucId: '',
      tuKhoa: '',
      tableLoading: false,
      doiTuongThanhTras: this.props.data && this.props.data.listDoiTuongThanhTra && this.props.data.listDoiTuongThanhTra.length > 0 ? this.props.data.listDoiTuongThanhTra : [],
      data: {
        tenMotDoiTuongThanhTra: '',
        doiTuongThanhTrasList: [],
        ten: '',
        doiTuongThanhTraInfo: [],
        tenNhieuDoiTuongThanhTra: '',
        thoiGianTienHanh: '',
        noiDungThanhTra: '',
        donViChuTriInfo: {
          coQuanQuanLyId: null,
          ten: ''
        },
        cuocThanhTraNhieuDoiTuong: this.props.data.cuocThanhTraNhieuDoiTuong ? this.props.data.cuocThanhTraNhieuDoiTuong : !this.props.data.cuocThanhTraNhieuDoiTuong,
        cuocThanhTraNhieuDoiTuongList: {
          text: "",
          type: ''
        },
        donViPhoiHop: [],
        doiTuongThanhTraId: '',
        doiTuongThanhTras: [],
        kyThanhTra: '',
        linhVucThanhTraList: [],
        hinhThucThanhTraChuyenNganhInfo: {
          text: '',
          type: ''
        },
        thucHienPhapLuatVeThanhTraList: [],
        chiTietLinhVuc: '',
        chucNangCuocThanhTraInfo: {
          text: '',
          type: ''
        },
        thoiHanThanhTra: '',
        kyTruocChuyenSang: false,
        daCoKetQuaDeXuat: false,
        phoiHopXuLy: false,

      },
      linhVucList: [],
      dataDonViChuTri: [],
      danhSachDonViPhoiHop: [],
      hinhThucThanhTraChuyenNganhList: [],
      thucHienPhapLuatVeThanhTraListCombobox: [],
      cuocThanhTraNhieuDoiTuongList: [
        {
          giaTri: 'true',
          ten: "Thanh tra nhiều đối tượng"
        },
        {
          giaTri: 'false',
          ten: "Thanh tra một đối tượng"
        },
      ],
      thucHienPhapLuatVeThanhTra: '',
      doiTuongSelectedList: [],
      checkAll: false,
      totalSelectedList: [],
      dataSelectDoiTuongCurrent: [],
      tempDataSelectDoiTuongCurrent: [],
      arrThemMoiIds: [],
      arrXoaIds: [],
      hasDataDeXuat: false,
      loadingSave: false,
      numberUnsuccess: 0,
      loadingImport: false,
      base64Content: '',
      fileName: '',
      mineType: '',
      maSoThue: '',
      quanHuyenId: '',
      dsQuanHuyen: [],
      phuongXaId: '',
      dsPhuongXa: [],
      diaChi: '',
      validLinhVucThanhTra: true
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isOpen !== this.props.isOpen && this.props.isOpen) {
      this.getDSDTDeXuatXuLy();
      this.getNhomDoiTuong();
      this.forceUpdate();
      this.getLinhVucThanhTra();
      this.getThucHienPhapLuatVeTT();
    }
  }

  componentDidMount() {
    if (!isEmpty(this.props.data.listDoiTuongThanhTra)) {
      const dataSelectDoiTuongCurrent = get(this.props.data, 'listDoiTuongThanhTra');
      let newItem = [];
      let state = this.state;
      this.props.data.listDoiTuongThanhTra.forEach(items => {
        newItem.push({
          id: items.doiTuongThanhTraId,
          ten: items.ten
        });
      });
      state.dataSelectDoiTuongCurrent = dataSelectDoiTuongCurrent;
      this.setState({
        doiTuongThanhTras: newItem,
        ten: this.props.data.ten ? this.props.data.ten : '',
        tenNhieuDoiTuongThanhTra: this.props.data.tenNhieuDoiTuongThanhTra ? this.props.data.tenNhieuDoiTuongThanhTra : '',
        thoiGianTienHanh: this.props.data.thoiGianTienHanh,
        hinhThucThanhTraChuyenNganh: this.props.data.hinhThucThanhTraChuyenNganh,
        data: {
          ...state,
          linhVucThanhTraList: this.props.data.linhVucThanhTraList && this.props.data.linhVucThanhTraList.map(item => item.giaTri),
          chiTietLinhVuc: this.props.data.chiTietLinhVuc,
          thucHienPhapLuatVeThanhTraList: this.props.data.thucHienPhapLuatVeThanhTraList && this.props.data.thucHienPhapLuatVeThanhTraList.map(item => item.giaTri),
        }
      });
    } else {
      const dataSelectDoiTuongCurrent = get(this.props.data, 'listDoiTuongThanhTra');
      let state = this.state;
      state.dataSelectDoiTuongCurrent = dataSelectDoiTuongCurrent;

      this.setState({
        doiTuongThanhTras: this.props.data.doiTuongThanhTras,
        ten: this.props.data.ten ? this.props.data.ten : '',
        tenNhieuDoiTuongThanhTra: this.props.data.tenNhieuDoiTuongThanhTra ? this.props.data.tenNhieuDoiTuongThanhTra : '',
        thoiGianTienHanh: this.props.data.thoiGianTienHanh,
        hinhThucThanhTraChuyenNganh: this.props.data.hinhThucThanhTraChuyenNganh,
        data: {
          ...state,
          linhVucThanhTraList: this.props.data.linhVucThanhTraList && this.props.data.linhVucThanhTraList.map(item => item.giaTri),
          chiTietLinhVuc: this.props.data.chiTietLinhVuc,
          thucHienPhapLuatVeThanhTraList: this.props.data.thucHienPhapLuatVeThanhTraList && this.props.data.thucHienPhapLuatVeThanhTraList.map(item => item.giaTri),
        }
      });
    }

    this.getLinhVuc();
    this.getNhomDoiTuong();
    this.getDonViChuTri();
    this.getHinhThucThanhTraChuyenNganh();
    this.getThucHienPhapLuatVeTT();
    this.getHinhThucKeHoachThanhTra();
    this.getLinhVucThanhTra();
    this.getChucNangCuocThanhTra();
    this.getDoiTuongThanhTra();
    this.getDSDTDeXuatXuLy();
    this.getQuanHuyen();
  }

  getLinhVucThanhTra() {
    let state = this.state;
    ThanhTra.actions.getLinhVucThanhTra.request().then(res => {
      if (res.data) {
        state.dataLinhVucThanhTra = res.data;
      }
      this.setState(state);
    });
  }

  getNhomDoiTuong() {
    ThanhTra.actions.getNhomDoiTuongThanhTras.request().then(res => {
      if (res.data._embedded) {
        this.setState({ nhomDTList: res.data._embedded.nhomDoiTuongThanhTras });
      }
    });
  }

  getQuanHuyen() {
    DuLieuHeThong.actions.getQuanHuyen.request().then(res => {
      if (res.data._embedded) {
        this.setState({
          dsQuanHuyen: res.data._embedded.donViHanhChinhs
        })
      }
    })
  }

  getPhuongXa(quanHuyenId = undefined) {
    if (quanHuyenId) {
      DuLieuHeThong.actions.getPhuongXa.request(null, { cha: quanHuyenId }).then(res => {
        this.setState({
          dsPhuongXa: get(res, 'data._embedded.donViHanhChinhs') || []
        })
      })
    }
  }

  getHinhThucKeHoachThanhTra() {
    ThanhTra.actions.getHinhThucKeHoachThanhTra.request().then(res => {
      if (res.data) {
        this.state.hinhThucKHTTList = res.data;
      } else {
        this.state.hinhThucKHTTList = [];
      }
      this.setState({ ...this.state });
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data) {
      let getDSDTDeXuatXuLy = [...this.state.getDSDTDeXuatXuLy];
      let getDSDTDeXuatXuLys = [...this.state.getDSDTDeXuatXuLys];
      let dataSelectDoiTuongCurrent = [];
      let arrThemMoi = [...this.state.arrThemMoiIds];
      let state = this.state;
      if (!isEmpty(nextProps.data.listDoiTuongThanhTra)) {
        dataSelectDoiTuongCurrent = get(nextProps.data, 'listDoiTuongThanhTra');
      } else {
        dataSelectDoiTuongCurrent = get(nextProps.data, 'doiTuongThanhTrasList');
      }
      state.dataSelectDoiTuongCurrent = dataSelectDoiTuongCurrent;
      if (isEmpty(this.state.arrThemMoiIds) && isArray(dataSelectDoiTuongCurrent)) {
        arrThemMoi = dataSelectDoiTuongCurrent && dataSelectDoiTuongCurrent.map(item => item.doiTuongThanhTraId);
      }
      let arrDv = nextProps.data.donViPhoiHop ? nextProps.data.donViPhoiHop.split(';') : [];
      const danhSachDonViPhoiHop = [];
      arrDv.map(item => {
        danhSachDonViPhoiHop.push({ ten: item });
      });
      if (!isEmpty(nextProps.totalDataDeXuat)) {
        const getDeXuat = nextProps.totalDataDeXuat.find(item => item.id === nextProps.idCS);
        if (!isEmpty(getDeXuat)) {
          getDSDTDeXuatXuLy = getDeXuat.dataDeXuat;
          getDSDTDeXuatXuLys = getDeXuat.dataDeXuats;
        }
      }
      this.setState({
        ...this.state,
        danhSachDonViPhoiHop,
        data: {
          ...nextProps.data,
          donViChuTriInfo: { ...nextProps.data.donViChuTriInfo },
          linhVucThanhTraInfo: { ...nextProps.data.linhVucThanhTraInfo },
          hinhThucThanhTraChuyenNganhInfo: { ...nextProps.data.hinhThucThanhTraChuyenNganhInfo },
          thucHienPhapLuatVeThanhTraInfo: { ...nextProps.data.thucHienPhapLuatVeThanhTraInfo },
          doiTuongThanhTras: nextProps.data.doiTuongThanhTras ? [...nextProps.data.doiTuongThanhTras] : [],
          thucHienPhapLuatVeThanhTraList: nextProps.data.thucHienPhapLuatVeThanhTraList && nextProps.data.thucHienPhapLuatVeThanhTraList.map(item => isString(item) ? item : item.giaTri),
          hinhThucThanhTraChuyenNganh: nextProps.data.hinhThucThanhTraChuyenNganh,
          linhVucThanhTraList: nextProps.data.linhVucThanhTraList && nextProps.data.linhVucThanhTraList.map(item => isString(item) ? item : item.giaTri),
          chiTietLinhVuc: nextProps.data.chiTietLinhVuc
        },
        getDSDTDeXuatXuLy,
        getDSDTDeXuatXuLys,
        arrThemMoiIds: arrThemMoi
      });
    }
  }

  getDonViChuTri() {
    ThanhTra.actions.getDonViChuTri.request().then(res => {
      if (res.data._embedded) {
        this.setState({
          dataDonViChuTri: res.data._embedded.coQuanQuanLies
        })
      }
    })
  }

  getHinhThucThanhTraChuyenNganh() {
    let state = this.state;
    ThanhTra.actions.getHinhThucThanhTraChuyenNganh.request().then(res => {
      if (res.data) {
        state.hinhThucThanhTraChuyenNganhList = res.data;
      }
    });
    this.setState(state);
  }

  getThucHienPhapLuatVeTT() {
    let state = this.state;
    ThanhTra.actions.getThucHienPhapLuatVeTT.request().then(res => {
      if (res.data) {
        state.thucHienPhapLuatVeThanhTraListCombobox = res.data;
      }
    });
    this.setState(state);
  }

  getLinhVuc() {
    Danhmuc.actions.getLinhVucDoiTuongThanhTra.request().then(res => {
      let linhVucList = [];
      if (res.data && res.data._embedded) {
        linhVucList = res.data._embedded.linhVucDoiTuongThanhTras;
      } else {
        linhVucList = [];
      }
      this.setState({ linhVucList });
    });
  }

  addDonVi(arr, value, e) {
    if (arr === 'doiTuongThanhTras' && typeof value != 'undefined') {
      value.preventDefault();
    } else if (arr === 'danhSachDonViPhoiHop' && typeof e != 'undefined') {
      e.preventDefault();
    }
    let newArr = [...this.state[arr]];

    let arrCheck = newArr.filter(state => {
      return state.ten == this.state[value]
    })
    if (this.state[value]) {
      if (arrCheck.length > 0) {
        this.setState({
          [value]: ''
        })
      } else {
        let newItem = {
          ten: this.state[value]
        }
        this.setState({
          [arr]: [
            ...this.state[arr],
            newItem
          ],
          [value]: ''
        })
      }
    }
    return;
  }

  removeDonVi(arr, index) {
    let newData = [...this.state[arr]];
    const getDSDTDeXuatXuLy = [...this.state.getDSDTDeXuatXuLy];
    const getDSDTDeXuatXuLys = [...this.state.getDSDTDeXuatXuLys];
    const doiTuongXoaIds = [...this.state.arrXoaIds];
    let doiTuongThanhTra = this.state.doiTuongThanhTras || {};
    newData.splice(index, 1);
    if (newData.length > 1) {
      this.state.data.cuocThanhTraNhieuDoiTuong = true;
    } else {
      this.state.data.cuocThanhTraNhieuDoiTuong = false;
    }
    const delItem = doiTuongThanhTra.find((item, i) => i === index);
    const delArr = getDSDTDeXuatXuLy.filter(item => item.id !== delItem.id);
    const delArrs = getDSDTDeXuatXuLys.filter(item => item !== delItem.id);
    const arrThemMoi = newData.map(item => item.id);
    doiTuongXoaIds.push(delItem.id);
    this.setState({
      ...this.state,
      getDSDTDeXuatXuLy: delArr,
      getDSDTDeXuatXuLys: delArrs,
      [arr]: newData,
      arrThemMoiIds: arrThemMoi,
      arrXoaIds: doiTuongXoaIds
    });
  }

  checkDuplicate(arr) {
    if (isArray(arr)) {
      const checkDuplicateArr = uniqBy(arr, 'doiTuongThanhTraId');
      return checkDuplicateArr;
    }
  }

  checkIsKiemTra() {
    const result = window.location.pathname.includes('kiem-tra');
    return result;
  }

  handleSave() {
    if (this.validateSubmitForm()) {
      //DonViChuTri
      let checkDVCT = this.state.dataDonViChuTri.findIndex(item => item.coQuanQuanLyId === this.state.data.donViChuTriInfo.coQuanQuanLyId);
      if (checkDVCT !== -1) this.state.data.donViChuTriInfo.ten = this.state.dataDonViChuTri[checkDVCT].ten;
      //ChucNangCuocThanhTra
      let checkCNCTT = this.state.dataChucNangCuocThanhTra.findIndex(item => item.giaTri === this.state.data.chucNangCuocThanhTraInfo.type);
      if (checkCNCTT !== -1) this.state.data.chucNangCuocThanhTraInfo.text = this.state.dataChucNangCuocThanhTra[checkCNCTT].ten;
      //danhSachDonViPhoiHop
      let listDV = [];
      this.state.danhSachDonViPhoiHop.forEach(item => {
        listDV.push(item.ten);
      });
      this.state.data.donViPhoiHop = listDV.join('; ');
      //hinhThucThanhTraChuyenNganh
      let checkHTTTCN = this.state.hinhThucThanhTraChuyenNganhList.findIndex(item => item.giaTri === this.state.data.hinhThucThanhTraChuyenNganhInfo.type);
      if (checkHTTTCN !== -1) this.state.data.hinhThucThanhTraChuyenNganhInfo.text = this.state.hinhThucThanhTraChuyenNganhList[checkHTTTCN].ten;
      //thucHienPhapLuatVeThanhTra
      // let checkTHPLTT = this.state.thucHienPhapLuatVeThanhTraList.findIndex(item => item.giaTri === this.state.data.thucHienPhapLuatVeThanhTraInfo.type);
      // if (checkTHPLTT !== -1) this.state.data.thucHienPhapLuatVeThanhTraInfo.text = this.state.thucHienPhapLuatVeThanhTraList[checkTHPLTT].ten;
      //get doiTuongThanhTra
      let newItem = [...this.state.doiTuongThanhTras];
      let newItems = [...this.state.doiTuongThanhTras];
      let getNewItems = [];
      let newListDoiTuong = [];
      const dataDoiTuong = [...this.state.dataSelectDoiTuongCurrent, ...this.state.tempDataSelectDoiTuongCurrent];
      const idCuocThanhTra = get(this.state.data, 'id') || get(this.props.data, 'id');
      this.state.doiTuongSelectedList.forEach(items => {
        newItem.push({
          id: items.doiTuongThanhTraId,
          ten: items.ten
        });
      });
      if (!isEmpty(newItem)) {
        dataDoiTuong.forEach((item) => {
          newItem.forEach(newItem => {
            if (item.doiTuongThanhTraId === newItem.id) {
              newListDoiTuong.push(item)
            }
          });
        });
      }
      const data = this.checkDuplicate(newListDoiTuong);

      if (newItem && newItem.length > 1) {
        this.state.data.doiTuongThanhTraInfo = null;
        newItems.map(item => {
          let itemIndex = isArray(this.state.dataDoiTuongThanhTra) && this.state.dataDoiTuongThanhTra.filter(tempItem => { return (tempItem.doiTuongThanhTraId === item.id) || (tempItem.doiTuongThanhTraId === item.doiTuongThanhTraId) });
          if (itemIndex.length > 0) {
            getNewItems.push(itemIndex[0]);
          }
        })
      } else if (newItem && newItem.length === 1) {
        let indexItem = isArray(this.state.dataDoiTuongThanhTra) && this.state.dataDoiTuongThanhTra.findIndex(item => get(item, 'doiTuongThanhTraId') === get(newItem, '[0].id'));
        if (indexItem !== -1) {
          this.state.data.doiTuongThanhTraInfo = this.state.dataDoiTuongThanhTra[indexItem];
          this.state.data.tenMotDoiTuongThanhTra = this.state.dataDoiTuongThanhTra[indexItem].ten;
        }
      }
      this.state.data.ten = this.state.ten;
      this.state.data.thoiGianTienHanh = this.state.thoiGianTienHanh;
      this.state.data.tenNhieuDoiTuongThanhTra = this.state.tenNhieuDoiTuongThanhTra;
      this.state.data.doiTuongThanhTras = newItem;
      this.state.data.doiTuongThanhTrasList = data;
      this.setState({
        ...this.state,
        dataSelectDoiTuongCurrent: data
      });
      this.props.dispatch({
        type: 'UPDATE_DEXUAT',
        dataDeXuat: this.state.getDSDTDeXuatXuLy,
        dataDeXuats: this.state.getDSDTDeXuatXuLys,
        idCTT: idCuocThanhTra,
        hasXuLy: false
      });
      this.props.dispatch({
        type: 'ADD_DOITUONGID',
        hasDeXuatXuLy: this.state.hasDataDeXuat,
        arrDoiTuongThemMoi: this.state.arrThemMoiIds,
        arrDoiTuongXoa: this.state.arrXoaIds,
        idCTT: idCuocThanhTra
      });
      this.props.onSave(this.state.data);
      this.props.onClose();
    }
  }

  handleSaveDoiTuongThanhTra() {
    let newItem = [...this.state.doiTuongThanhTras];
    let getDSDTDeXuatXuLy = [...this.state.getDSDTDeXuatXuLy];
    let getDSDTDeXuatXuLys = [...this.state.getDSDTDeXuatXuLys];
    const data = [...this.state.doiTuongSelectedList];
    let dataCurrentDoiTuong = [...this.state.tempDataSelectDoiTuongCurrent];
    let arrThemMoi = [...this.state.arrThemMoiIds];
    let arrXoaIds = [...this.state.arrXoaIds];

    data.map(item => {
      dataCurrentDoiTuong.push(item);
    })
    this.state.doiTuongSelectedList.forEach(items => {
      newItem.push({
        id: items.doiTuongThanhTraId,
        ten: items.ten
      });
    });

    const selectDoiTuongIds = data.map(item => item.doiTuongThanhTraId);

    const newArrXoa = arrXoaIds.filter(item => {
      if (selectDoiTuongIds.indexOf(item) === -1) {
        return item;
      }
    });
    // Gộp hai array
    arrThemMoi = union(arrThemMoi, selectDoiTuongIds);
    const getDeXuatCurrent = this.props.dataDXOld.find(item => item.idDeXuatOld === this.props.idCS);
    if (!isEmpty(getDeXuatCurrent)) {
      // Lấy ra phần tử giống nhau
      const getDuplicate = intersection(selectDoiTuongIds, getDeXuatCurrent.dataDeXuatsOld);
      if (!isEmpty(getDuplicate)) {
        const deXuatDuplicate = getDeXuatCurrent.dataDeXuatOld.filter(item => {
          if (getDuplicate.indexOf(item.id) !== -1) {
            return item;
          }
        });
        const deXuatDuplicateIds = deXuatDuplicate.map(item => item.id);
        // Nối 2 array với nhau
        getDSDTDeXuatXuLy = concat(getDSDTDeXuatXuLy, deXuatDuplicate);
        getDSDTDeXuatXuLys = concat(getDSDTDeXuatXuLys, deXuatDuplicateIds);
      }
    }

    if (newItem && newItem.length > 1) {
      this.state.data.cuocThanhTraNhieuDoiTuong = true;
    } else {
      this.state.data.cuocThanhTraNhieuDoiTuong = false;
    }
    this.setState({
      getDSDTDeXuatXuLy,
      getDSDTDeXuatXuLys,
      doiTuongThanhTras: newItem,
      isOpen: false,
      nhomDoiTuongThanhTraId: '',
      tempDataSelectDoiTuongCurrent: dataCurrentDoiTuong,
      arrThemMoiIds: arrThemMoi,
      arrXoaIds: newArrXoa
    });
    this.state.doiTuongSelectedList = [];
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['editCuocTT'].map(validator => {
      if (pass)
        pass = validator.validate();
      else {
        validator.validate();
      }
    });
    if (this.state.doiTuongThanhTras.length === 0) {
      Toastr(`Phải chọn ít nhất một đối tượng ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`, 'error');
      pass = false;
    }
    if (isEmpty(this.state.data.linhVucThanhTraList) && this.state.data.chucNangCuocThanhTraInfo.type !== "CHUYEN_NGANH") {
      this.setState({validLinhVucThanhTra: false});
      pass = false;
    }
    return pass;
  }

  changeCheckbox(name, e) {
    this.setState({
      data: {
        ...this.state.data,
        [name]: e.target.checked
      }
    });
  }

  onChangeTuKhoa(name, e) {
    this.state.tuKhoa = e.target.value;
  }

  onChangeMaSoThue(e) {
    this.state.maSoThue = e.target.value;
  }

  onChangeDiaChi(e) {
    this.state.diaChi = e.target.value;
  }

  onChange(name, e) {
    let state = this.state;
    if (name == 'chiTietLinhVuc') {
      state.data.chiTietLinhVuc = e.target.value;
    } else if (name == 'ten') {
      state.ten = e.target.value;
    } else if (name == 'linhVucId') {
      state.linhVucId = e.target.value;
    } else if (name == 'nhomDoiTuongThanhTraId') {
      state.nhomDoiTuongThanhTraId = e.target.value;
    } else if (name == 'tenNhieuDoiTuongThanhTra') {
      state.tenNhieuDoiTuongThanhTra = e.target.value;
    } else if (name == 'doiTuongThanhTra') {
      state.doiTuongThanhTra = e.target.value;
    } else if (name == 'phamViThanhTra') {
      state.data.kyThanhTra = e.target.value;
    } else if (name == 'thoiHanThanhTra') {
      state.data.thoiHanThanhTra = e.target.value;
    } else if (name == 'thoiGianTienHanh') {
      state.thoiGianTienHanh = e.target.value;
    } else if (name == 'noiDungThanhTra') {
      state.data.noiDungThanhTra = e.target.value;
    } else if (name == 'donViChuTri') {
      state.data.donViChuTriInfo.coQuanQuanLyId = e.target.value;
    } else if (name == 'hinhThucThanhTraChuyenNganh') {
      state.data.hinhThucThanhTraChuyenNganhInfo.type = e.target.value;
    } else if (name == 'chucNangCuocThanhTra') {
      state.data.chucNangCuocThanhTraInfo.type = e.target.value;
    } else if (name == 'linhVucThanhTraList') {
      state.data.linhVucThanhTraList = e.map(item => item.value);
      state.validLinhVucThanhTra = true;
    } else if (name == 'thucHienPhapLuatVeThanhTraList') {
      state.data.thucHienPhapLuatVeThanhTraList = e.map(item => item.value);
    } else if (name == 'quanHuyenId') {
      if (!e.target.value) {
        state.quanHuyenId = e.target.value;
        state.phuongXaId = '';
        state.dsPhuongXa = [];
      } else {
        state.quanHuyenId = e.target.value;
        state.phuongXaId = '';
        this.getPhuongXa(e.target.value);
      }
    } else if (name == 'phuongXaId') {
      state.phuongXaId = e.target.value;
    } else {
      state[name] = e.target.value;
    }
    this.setState(state);
  }

  openDialog() {
    this.timKiem();
    this.state.totalSelectedList = [];
    this.setState({
      isOpen: true
    });
  }

  timKiem(statusTimKiem) {
    this.state.checkAll = false;
    let d = new Date();
    let getNamTT = d.getFullYear() + 1;
    const pageData = {
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      sort: 'ngaySua,desc',
    }
    let params = {
      pageData,
      namThanhTra: getNamTT
    }

    if (statusTimKiem) {
      params.pageData.page = 0;
    }

    if (!isEmpty(this.state.doiTuongThanhTras)) {
      const idsDoiTuong = this.state.doiTuongThanhTras.map(item => item.id);
      this.state.doiTuongSelectedList.forEach(item => {
        idsDoiTuong.push(item.doiTuongThanhTraId);
      });
      params.idDoiTuongDaCoCuocs = idsDoiTuong;
    }

    if (this.state.tuKhoa) {
      params.tenDoiTuong = this.state.tuKhoa;
    }
    if (this.state.linhVucId) {
      params.linhVucId = this.state.linhVucId;
    }
    if (this.state.nhomDoiTuongThanhTraId) {
      params.nhomDoiTuongThanhTraId = this.state.nhomDoiTuongThanhTraId;
    }
    if (!isEmpty(this.state.maSoThue)) {
      params.maSoThue = this.state.maSoThue;
    }
    if (this.state.diaChi) {
      params.tuKhoa = this.state.diaChi;
    }
    if (this.state.quanHuyenId) {
      params.quanHuyenId = Number(this.state.quanHuyenId);
    }
    if (this.state.phuongXaId) {
      params.phuongXaId = Number(this.state.phuongXaId);
    }
    this.setState({ tableLoading: true });
    Danhmuc.actions.doiTuongThanhTraChuaCoCuoc.request(null, params).then(res => {
      if (res.data._embedded) {
        let data = get(res, 'data._embedded.doiTuongThanhTras');
        if (!isEmpty(this.state.totalSelectedList) && isArray(this.state.totalSelectedList)) {
          const newData = data.map(item => {
            this.state.totalSelectedList.forEach(itemDoiTuong => {
              if (item.doiTuongThanhTraId === itemDoiTuong.doiTuongThanhTraId) {
                item.selected = true;
              }
            });
            return item;
          });
          data = newData;
        }
        this.setState({
          ketQuaTimKiemList: data,
          pageData: res.data.page,
          tableLoading: false
        });
      } else {
        this.setState({
          ketQuaTimKiemList: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          tableLoading: false
        });
      }
    });
  }

  getDoiTuongThanhTra() {
    let d = new Date();
    let getNamTT = d.getFullYear() + 1;
    ThanhTra.actions.getDoiTuongThanhTra.request({ namThanhTra: getNamTT }).then(res => {
      if (res.data._embedded) {
        this.setState({
          dataDoiTuongThanhTra: res.data._embedded.doiTuongThanhTras
        })
      }
    })
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.timKiem();
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.timKiem();
  }

  hanldeRemove(index) {
    const arrThemMoiIds = [...this.state.arrThemMoiIds];
    let doiTuongSelectedList = [...this.state.doiTuongSelectedList];
    const itemDelete = doiTuongSelectedList.find((item, i) => i === index);
    const newArrThemMoiIds = arrThemMoiIds.filter(item => item !== itemDelete.doiTuongThanhTraId);
    doiTuongSelectedList.splice(index, 1);
    this.setState({
      ...this.state,
      doiTuongSelectedList,
      arrThemMoiIds: newArrThemMoiIds
    }, () => {
      this.timKiem();
    });
  }

  kiemTraTenDoiTuong(idDoiTuong, check) {
    let d = new Date();
    let getNam = d.getFullYear() + 1;
    let getTenDoiTuong = '';
    ThanhTra.actions.getKiemTraDoiTuongTT.request({
      doiTuongThanhTraId: idDoiTuong,
      namThanhTra: getNam
    }).then(res => {
      if (res && res.data) {
        let idPushCoQuan = [];
        res.data._embedded.coQuanQuanLies.map(items => {
          idPushCoQuan.push(items.ten)
        })
        let tenDoituong = this.state.ketQuaTimKiemList.find(items => items.doiTuongThanhTraId === idDoiTuong);
        if (this.state.checked && check) {
          this.setState({
            isOpenDT: true,
            getTenDoiTuong: get(tenDoituong, 'ten'),
            idPushCoQuan: idPushCoQuan
          });
        }
        if (check === false) {
          let msgWarning = `Đối tượng ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} ` + getTenDoiTuong + ` đã được chọn làm đối tượng ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} tại đơn vị: ` + idPushCoQuan;
          Toastr(msgWarning, 'thongbao');
        }
      }
    })
    return 0;
  }

  async handleSelectedDoiTuong(item) {
    let check = true;
    item.selected = !item.selected;
    if (item.selected) {
      let newtotalSelectedList = [...this.state.totalSelectedList];
      if (item.daTrung === true) {
        this.setState({
          doiTuongThanhTraId: item.doiTuongThanhTraId
        });
      }
      newtotalSelectedList.push(item);
      await this.setState({
        checked: item.selected,
        totalSelectedList: newtotalSelectedList,
      });
      this.kiemTraTenDoiTuong(item.doiTuongThanhTraId, check);
    } else {
      let newtotalSelectedList = [...this.state.totalSelectedList];
      newtotalSelectedList.map((value, index) => {
        if (value.doiTuongThanhTraId == item.doiTuongThanhTraId) {
          newtotalSelectedList.splice(index, 1);
        }
      });
      // Toastr(null,'newtotalSelectedList');
      this.setState({
        totalSelectedList: newtotalSelectedList
      });
    }
  }

  suggesttion(dataSearch) {
    this.setState({
      isSearch: true
    }, () => {
      let params = {
        tuKhoa: dataSearch
      }

      if (this.state.doiTuongThanhTra) {
        params.doiTuongIds = this.state.doiTuongThanhTra
      }
      Danhmuc.actions.getDoiTuongThanhTra.request(params).then(res => {
        if (res.data._embedded) {
          this.setState({
            dataSuggest: res.data._embedded.doiTuongThanhTras,
            isSearch: false
          })
        } else {
          this.setState({
            dataSuggest: [],
            isSearch: false
          })
        }
      })
    })
  }

  handleSelectedAll() {
    let check = false;
    this.state.checkAll = !this.state.checkAll;
    this.state.ketQuaTimKiemList.map((item) => {
      item.selected = this.state.checkAll;
      if (this.state.checkAll) {
        this.state.totalSelectedList.push(item);
        this.kiemTraTenDoiTuong(item.doiTuongThanhTraId, check);
      } else {
        this.state.totalSelectedList = [];
        Toastr(null, 'resetclear');
      }
    });
    this.setState({ ...this.state });
  }

  themVaoCuocTT() {
    const doiTuongSelectedList = [...this.state.doiTuongSelectedList, ...this.state.totalSelectedList];
    this.state.totalSelectedList = [];
    this.setState({
      doiTuongSelectedList,
      totalSelectedList: []
    }, () => {
      this.timKiem();
    })
  }

  getChucNangCuocThanhTra() {
    ThanhTra.actions.getChucNangCuocThanhTra.request().then(res => {
      if (res.data) {
        this.setState({
          dataChucNangCuocThanhTra: res.data
        });
      }
    })
  }

  closeDialogThongBao() {
    this.setState({
      isOpenThongBao: false
    });
  }

  closeDialog(name) {
    const doiTuongSelectedList = [];
    const tempDataSelectDoiTuongCurrent = [];
    this.setState({
      [name]: false,
      tempDataSelectDoiTuongCurrent,
      doiTuongSelectedList
    });
  }

  closeDialogDT(name) {
    let state = this.state;
    let newtotalSelectedList = [...this.state.totalSelectedList];
    let data = [...this.state.dataSelectDoiTuongCurrent];
    let newketQuaTimKiemList = [...this.state.ketQuaTimKiemList];

    if (this.state.doiTuongThanhTraId) {
      newtotalSelectedList.map((value, index) => {
        if (value.doiTuongThanhTraId == this.state.doiTuongThanhTraId) {
          newtotalSelectedList.splice(index, 1);
          data.splice(index, 1);
        }
      });
    }
    newketQuaTimKiemList.map(item => {
      if (item.doiTuongThanhTraId === this.state.doiTuongThanhTraId) {
        item.selected = false;
      }
    });
    data.map(item => {
      if (item.doiTuongThanhTraId === this.state.doiTuongThanhTraId) {
        item.selected = false;
      }
    });
    state.isOpenDT = false;
    this.setState({
      totalSelectedList: newtotalSelectedList,
      ketQuaTimKiemList: newketQuaTimKiemList,
      dataSelectDoiTuongCurrent: data,
      isOpenDT: false
    });
  }

  openDialogDT() {
    this.setState({
      isOpenDT: true
    });
  }

  onCloseDT() {
    this.setState({
      isOpenDT: false
    });
  }

  getDSDTDeXuatXuLy() {
    ThanhTra.actions.getDanhSachDoiTuongDaDeXuatXuLy.request({ cuocThanhTraId: this.props.data.id }).then(res => {
      let getDSDTDeXuatXuLy = [];
      let getDSDTDeXuatXuLys = [];
      let hasDataDeXuat = false;
      if (!isEmpty(res.data)) {
        hasDataDeXuat = true;
        res.data.map(item => {
          if (item) {
            getDSDTDeXuatXuLy.push({
              id: item.dttt && item.dttt.id ? item.dttt.id : null,
              doiTuong: item.dttt && item.dttt.ten ? item.dttt.ten : null,
              yKien: item.noiDungDeXuat || null
            });
            getDSDTDeXuatXuLys.push(item.dttt.id);
          }
        });
      }
      this.props.dispatch({
        type: 'ADD_DEXUAT',
        dataDeXuat: getDSDTDeXuatXuLy,
        dataDeXuats: getDSDTDeXuatXuLys,
        id: this.props.idCS,
        hasDataDeXuat: hasDataDeXuat
      });
      if (!this.props.hasXuLy) {
        this.setState({
          getDSDTDeXuatXuLys,
          getDSDTDeXuatXuLy
        }, () => {
          this.props.dispatch({
            type: 'UPDATE_DEXUAT',
            dataDeXuat: getDSDTDeXuatXuLy,
            dataDeXuats: getDSDTDeXuatXuLys,
            idCTT: this.props.idCS
          });
        });
      }
    });
  }

  onClose() {
    const doiTuongSelectedList = [];
    const tempDataSelectDoiTuongCurrent = [];
    this.setState({
      doiTuongSelectedList,
      tempDataSelectDoiTuongCurrent
    }, () => {
      this.props.onClose();
    });
  }

  uploadFile(e) {
    if (this.refs.btnUpload.files[0]) {
      const fileName = this.refs.btnUpload.files[0].name;
      const ext = fileName.split('.').pop().toLowerCase();
      const fileSize = e.target.files[0].size;
      const listExcel = ['xls', 'xlsx']
      if (!includes(listExcel, ext)) {
        Toastr(msg.fileExcel, 'warning');
      } else if (fileSize > LimitFileSize * 1024 * 1024) {
        Toastr(msg.fileSizeErr, 'warning');
      } else if (fileSize == 0) {
        Toastr(msg.fileSizeNull, 'warning');
      } else {
        let params = { field: 'file', file: this.refs.btnUpload.files[0] };

        params.progress = (progress) => {
          const progressBar = Math.round((progress.loaded * 100) / progress.total);

          this.setState({ progress: progressBar });
        }
        Reception.actions.postFileUpload.request('', params).then(res => {
          let checkURL = '';
          if (res && res.data && !checkServerLive) {
            checkURL = res.data;
          } else if (res && res.data && checkServerLive) {
            checkURL = res.data.id;
          }
          this.setState({
            data: {
              ...this.state.data,
              progress: 0,
              tenFile: fileName,
              duongDan: checkURL,
            },
            isError: false
          }, () => {
            this.addDoiTuongThanhTra(params)
          });
        }).catch(error => {
          this.setState({
            progress: 0,
            isError: true
          });
        });
      }
    }
  }

  addDoiTuongThanhTra(params) {
    this.setState({
      loadingSave: true,
      loadingImport: true
    });
    Reception.actions.importFileDoiTuong.request('', params).then(res => {
      if (!isEmpty(res.data)) {
        const { doiTuongThanhTraExists, numberUnsuccess, doiTuongThanhTraNotExists } = res.data;
        this.setState({
          errorImport: false,
          data: {
            ...this.state.data,
            doiTuongThanhTraImport: doiTuongThanhTraExists.map(item => ({ id: item.id })),
            cuocThanhTraNhieuDoiTuong: doiTuongThanhTraExists.length > 1 || this.state.data.cuocThanhTraNhieuDoiTuong,
          },
          base64Content: get(doiTuongThanhTraNotExists, 'base64Content') || '',
          fileName: get(doiTuongThanhTraNotExists, 'fileName') || '',
          mineType: get(doiTuongThanhTraNotExists, 'mineType') || '',
          numberUnsuccess: numberUnsuccess
        });
      }
    }).catch(error => {
      const message = get(error, 'response.data.errors[0].description');
      this.setState({
        errorImport: true,
        data: {
          ...this.state.data,
          duongDan: '',
          tenFile: '',
          cuocThanhTraNhieuDoiTuong: false
        }
      }, () => {
        Toastr(message, 'error');
      });
    }).finally(() => {
      this.setState({
        loadingSave: false,
        loadingImport: false,
        isOpenThongBao: this.state.numberUnsuccess > 0
      });
    });
  }

  convertEndCode(data) {
    const result = encodeURIComponent(data);
    return result;
  }

  render() {
    let newItem = [];
    let showDonViPhoiHop = false;
    let countDTTT = this.state.doiTuongThanhTras && this.state.doiTuongThanhTras.length;
    let checkDSXL = this.state.getDSDTDeXuatXuLy && this.state.getDSDTDeXuatXuLy.length;
    if (this.props.isOpen === true) {
      if (this.state.doiTuongThanhTras.length > 0) {
        this.state.doiTuongThanhTras.forEach(items => {
          newItem.push({
            id: items.doiTuongThanhTraId || items.id,
            ten: items.ten
          });
        });
      }
    } else if (this.props.isOpen === false) {
      if (this.props.data && this.props.data.listDoiTuongThanhTra && this.props.data.listDoiTuongThanhTra.length > 0) {
        this.props.data.listDoiTuongThanhTra.forEach(items => {
          newItem.push({
            id: items.doiTuongThanhTraId || items.id,
            ten: items.ten
          });
        });
        if (this.props.data && this.props.data.doiTuongThanhTras && this.props.data.doiTuongThanhTras.length > 0) {
          newItem = this.props.data.doiTuongThanhTras;
        }
      } else if (this.props.data && this.props.data.doiTuongThanhTras && this.props.data.doiTuongThanhTras.length > 0) {
        newItem = this.props.data.doiTuongThanhTras;
      }
      if (newItem) {
        this.state.doiTuongThanhTras = newItem;
      } else if (this.props.data && this.props.data.doiTuongThanhTras && this.props.data.doiTuongThanhTras.length > 0) {
        this.state.doiTuongThanhTras = this.props.data.doiTuongThanhTras;
      } else {
        this.props.data.doiTuongThanhTras = [];
      }
    }

    const newItemIds = newItem.map(item => item.id);
    const duplicateIds = intersection(newItemIds, this.state.getDSDTDeXuatXuLys);
    showDonViPhoiHop = !isEmpty(duplicateIds);
    return (
      <div>
        <Dialog
          isOpen={this.state.isOpenDT}
          onClose={this.closeDialogDT.bind(this, 'isOpenDT')}
          title='Thông báo'
          className="reception-dialog delete-dialog wrap-block"
        >
          <div className="pt-dialog-body mb0 hlDialog">
            <div className='pt10 txt-center'>
              {`Đối tượng ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}
              <h2>{` "${this.state.getTenDoiTuong}" `}</h2>
              {`đã được chọn làm đối tượng ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} của`} {' '}
              {this.state.idPushCoQuan.join(', ')}
            </div>
            <div className='pb20 txt-center'>
              Bạn có đồng ý thêm
              <h2>{` "${this.state.getTenDoiTuong}" `}</h2>
              <span>{`vào kế hoạch ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} không?`}</span>
            </div>
          </div>
          <div className="box-bottom col-100">
            <Link className="btn-action btn-close action-todo" onClick={this.closeDialogDT.bind(this)}><span>Không</span></Link>
            <Link className="btn-action btn-green action-todo" onClick={this.onCloseDT.bind(this)}><span>Đồng ý</span></Link>
          </div>
        </Dialog>
        <Dialog
          isOpen={this.props.isOpen}
          onClose={this.onClose.bind(this)}
          title={this.props.keHoach ? `Thay thế cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}` : `Chỉnh sửa cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}
          className="dialog-them-moi-dttt dialog-default wrap-block"
        >
          <section className='wrap-block'>
            <div className='row pl15 pr15'>
              <h2 className='title-14 p20'>{`1. Thông tin cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}</h2>
            </div>
            <div className='row pl30 pr30'>
              <form className='wrap-tt-dvph col-100 no-gutter' onSubmit={this.addDonVi.bind(this, 'doiTuongThanhTras')}>
                <TextArea channel="editCuocTT" require bindValidator={this} triggerOnblur label={`Tên cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`} className='col-100' value={this.state.ten} onChange={this.onChange.bind(this, 'ten')} name='ten' maxLength={500} />
                {
                  checkDSXL > 0 &&
                  <div className="row">
                    <DataTable
                      header={header.thanhTra.DMTTDX}
                      dataList={this.state.getDSDTDeXuatXuLy}
                      hideButtonExport
                      hidePagination
                      parent={this}>
                      <RowItemThanhTraDeXuat />
                    </DataTable>
                  </div>
                }
                <div>
                  <div className='wrap-input-tt-dvph col-25 mrt22'>
                    <Link className="col-100 no-gutter btn-green btn-pullleft" onClick={this.openDialog.bind(this)}><i className="tt tt-addfile"></i>{`Đối tượng ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}</Link>
                  </div>
                  <div className='wrap-input-tt-dvph col-15 mrt22'>
                    <div className="upload_file_content pt10">
                      <input type="file" name='uploadFile' className="upload btn-green btn-pullleft" ref='btnUpload' onChange={this.uploadFile.bind(this)} />
                      <span htmlFor="file">{isEmpty(this.state.data.duongDan) ? 'Tải lên tập tin' : 'Tải lại tập tin'}</span>
                    </div>
                  </div>
                  <div className='wrap-input-tt-dvph col-25 mrt22'>
                    {
                      checkServerLive && !isEmpty(this.state.data.duongDan) && !this.state.loadingImport &&
                      <Link className="txt-blue txt-underline" onClick={() => { downloadFile(get(this.state.data, 'duongDan'), get(this.state.data, 'tenFile')) }}>{this.state.data.tenFile}</Link>
                    }
                    {
                      !checkServerLive && !isEmpty(this.state.data.duongDan) && !this.state.loadingImport &&
                      <Link className="txt-blue txt-underline" onClick={downloadExcel.bind(this, get(this.state.data, 'duongDan'), get(this.state.data, 'tenFile'))}>{this.state.data.tenFile}</Link>
                    }
                    {
                      this.state.loadingImport &&
                      <span className='icon-loader mt10'></span>
                    }
                  </div>
                  <div className='col-100 mb18'>
                    <div className='ds-tt-dvph'>
                      {
                        newItem &&
                        newItem.map((item, i) => {
                          return (
                            <div className='tt-dvph-item' key={i}>
                              <span className="tt-dvph-icon" onClick={this.removeDonVi.bind(this, 'doiTuongThanhTras', i)}>×</span>
                              <span className={classnames('tt-dvph-value', {
                                'highlighttratrung': this.state.getDSDTDeXuatXuLys.indexOf(item.id) !== -1
                              })}>{item.ten}
                              </span>
                            </div>
                          )
                        })
                      }
                    </div>
                  </div>
                </div>
              </form>
              <DropDownMulipleUse label={`Hoạt động ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`} keyName='giaTri' confirm={true} placeholder={null} valueName='ten' className='col-25' data={this.state.dataChucNangCuocThanhTra} selectedValue={this.state.data.chucNangCuocThanhTraInfo ? this.state.data.chucNangCuocThanhTraInfo.type : ''} onChange={this.onChange.bind(this, 'chucNangCuocThanhTra')} name='chucNangCuocThanhTra' />
              <div className='row pl30 pr30'>

                <ShowIf condition={this.props.data.chucNangCuocThanhTraInfo && this.props.data.chucNangCuocThanhTraInfo.type == 'HANH_CHINH'}>
                  <DropDownChonLinhVucThanhTraMultiple
                    label={`Lĩnh vực ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}
                    confirm={true}
                    placeholder={null}
                    className='col-25'
                    data={this.state.dataLinhVucThanhTra.map(item => ({
                      label: item.ten,
                      value: item.giaTri
                    }))}
                    selectedValue={this.state.data.linhVucThanhTraList}
                    onChange={this.onChange.bind(this, 'linhVucThanhTraList')}
                    name='linhVucThanhTraList'
                    require
                    validLinhVucThanhTra={this.state.validLinhVucThanhTra}
                  />
                </ShowIf>
                {
                  this.props.data.chucNangCuocThanhTraInfo && this.props.data.chucNangCuocThanhTraInfo.type == 'CHUYEN_NGANH' &&
                  <DropDown className='col-25' label={`Hình thức ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} chuyên ngành`} placeholder options={this.state.hinhThucThanhTraChuyenNganhList} keyName="giaTri" valueName="ten" selectedValue={this.state.data.hinhThucThanhTraChuyenNganhInfo ? this.state.data.hinhThucThanhTraChuyenNganhInfo.type : ''} onChange={this.onChange.bind(this, 'hinhThucThanhTraChuyenNganh')} name='hinhThucThanhTraChuyenNganh' bindValidator={this} channel='editCuocTT' require />
                }
                <ShowIf condition={(this.props.data.chucNangCuocThanhTraInfo && this.props.data.chucNangCuocThanhTraInfo.type == 'HANH_CHINH' && this.state.data.linhVucThanhTraList.includes('THANH_TRA_TRACH_NHIEM'))}>
                  <DropDownMultipleSelect
                    label=" "
                    className='col-25 mt16'
                    bindValidator={this}
                    channel="formTaoDon"
                    value={this.state.data.thucHienPhapLuatVeThanhTraList}
                    options={this.state.thucHienPhapLuatVeThanhTraListCombobox.map(item => ({
                      label: item.ten,
                      value: item.giaTri
                    }))}
                    onChange={this.onChange.bind(this, 'thucHienPhapLuatVeThanhTraList')}
                    placeholder=''
                    closeMenuOnSelect={false}
                  />
                </ShowIf>
                <ShowIf condition={(this.props.data.chucNangCuocThanhTraInfo && this.props.data.chucNangCuocThanhTraInfo.type == 'HANH_CHINH')}>
                  <Input
                    className="col-25"
                    label="Chi tiết lĩnh vực"
                    placeholder="Nhập..."
                    value={this.state.data.chiTietLinhVuc}
                    onChange={this.onChange.bind(this, 'chiTietLinhVuc')}
                    name='chiTietLinhVuc'
                    bindValidator={this}
                    channel='formTaoDon'
                    maxLength={255}
                  />
                </ShowIf>
              </div>
            </div>
            <div className='row pl30 pr30'>
              <Input label={`Thời kỳ ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`} value={this.state.data.kyThanhTra} onChange={this.onChange.bind(this, 'phamViThanhTra')} name='phamViThanhTra' className="col-25" require={true} bindValidator={this} channel="editCuocTT" />
              <InputNumber label="Thời hạn (ngày)" value={this.state.data.thoiHanThanhTra} onChange={this.onChange.bind(this, 'thoiHanThanhTra')} name='thoiHanThanhTra' className="col-25" maxLength={255} />
              <Input label="Thời gian tiến hành" value={this.state.thoiGianTienHanh} onChange={this.onChange.bind(this, 'thoiGianTienHanh')} name='thoiGianTienHanh' className="col-25" />
              <ShowIf condition={countDTTT === 1 && showDonViPhoiHop ? true : false}>
                <Checkbox className='col-100 pt-large pt-dvph' name="phoiHopXuLy" checked={this.state.data.phoiHopXuLy} onChange={this.changeCheckbox.bind(this, 'phoiHopXuLy')}>
                  <span className="span-checkbox span-position-label">Đơn vị phối hợp</span>
                </Checkbox>

              </ShowIf>

              <TextArea className='col-100' label={`Nội dung ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`} value={this.state.data.noiDungThanhTra} onChange={this.onChange.bind(this, 'noiDungThanhTra')} name='noiDungThanhTra' rows={3} placeholder='Nhập...' require={true} bindValidator={this} channel="editCuocTT" maxLength={500}/>
              {/* <DropDownTreeSelectOneElement label="Đơn vị chủ trì" className='col-25' placeholder dataOptions={this.state.dataDonViChuTri} value={this.state.data.donViChuTriInfo.coQuanQuanLyId} onChange={this.onChange.bind(this, 'donViChuTri')} name='donViChuTri' propertyChildren='coQuanQuanLyCha' propertyParent='coQuanQuanLyId' require={true} bindValidator={this} channel="editCuocTT"/> */}

              {/* <form className='wrap-tt-dvph col-100 no-gutter' onSubmit={this.addDonVi.bind(this, 'danhSachDonViPhoiHop','donViPhoiHop')}>
              <div className='wrap-input-tt-dvph col-25'>
                <Input label='Đơn vị phối hợp' placeholder='Nhập...' className='col-100 no-gutter' value={this.state.donViPhoiHop} onChange={this.onChange.bind(this, 'donViPhoiHop')} name='donViPhoiHop'/>
                <button className='btn-add-dvph' type='submit'></button>
              </div>
              <div className='col-75 mb18'>
                <div className='ds-tt-dvph'>
                  {
                    this.state.danhSachDonViPhoiHop.map((item,i) => {
                      return (
                        <div className='tt-dvph-item' key={i}>
                          <span className="tt-dvph-icon" onClick={this.removeDonVi.bind(this, 'danhSachDonViPhoiHop', i)}>×</span>
                          <span className="tt-dvph-value">{item.ten}</span>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
            </form> */}
            </div>
          </section>
          <div className='row pl15 pr15'>
            <span className='line-border mt5 mb0'></span>
          </div>
          <div className="action-form-wrap pt20">
            <div className="box-bottom">
              <Link className="btn-action btn-close" onClick={this.onClose.bind(this)}><span>Đóng</span></Link>
              <Link
                className={classnames('btn-action btn-save', {
                  'btn-loading-inline': this.state.loadingSave
                })}
                onClick={this.handleSave.bind(this)}
              >
                <span>Lưu</span>
              </Link>
            </div>
          </div>
        </Dialog>
        <Dialog
          isOpen={this.state.isOpen}
          onClose={this.closeDialog.bind(this, 'isOpen')}
          title={`Thêm mới cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}
          className="dialog-them-moi-dttt dialog-default wrap-block"
        >
          <div className='row pl30 pr30'>
            <div className='col-100'>
              <h2 className='title-14 pt20 pb15'>{`1. Tìm kiếm đối tượng ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}</h2>
            </div>
            <Input className='col-28' label='Đối tượng' value={this.state.tuKhoa} onChange={this.onChangeTuKhoa.bind(this, 'tuKhoa')} name='tuKhoa' placeholder='Nhập tên đối tượng...' />
            <Input className='col-28' label='Mã số thuế' value={this.state.maSoThue} onChange={this.onChangeMaSoThue.bind(this)} name='maSoThue' placeholder='Nhập mã số thuế...' />
            <DropDown className='col-28' label="Nhóm đối tượng" selectedValue={this.state.nhomDoiTuongThanhTraId} onChange={this.onChange.bind(this, 'nhomDoiTuongThanhTraId')} name='nhomDoiTuongThanhTraId' placeholder options={this.state.nhomDTList} keyName="nhomDoiTuongThanhTraId" valueName="ten" />
            <DropDown
              className='col-28'
              label="Huyện/TP"
              selectedValue={this.state.quanHuyenId}
              onChange={this.onChange.bind(this, 'quanHuyenId')}
              name='quanHuyenId'
              placeholder
              options={this.state.dsQuanHuyen} keyName="donViHanhChinhId" valueName="ten"
            />
            <DropDown
              className='col-28'
              label="Phường/Xã"
              selectedValue={this.state.phuongXaId}
              onChange={this.onChange.bind(this, 'phuongXaId')}
              name='phuongXaId'
              placeholder
              options={get(this.state, 'dsPhuongXa', [])} keyName="donViHanhChinhId" valueName="ten"
            />
            <Input className='col-28' label="Địa chỉ" value={this.state.diaChi} onChange={this.onChangeDiaChi.bind(this)} name='diaChi' placeholder='Nhập' />
            <div className='col-15 mt22'>
              <Link className='btn-green ml10' onClick={this.timKiem.bind(this, true)}>
                <i className='tt-search'></i>Tìm kiếm
              </Link>
            </div>
          </div>

          <div className='row pl10 pr10 '>
            <div className='col-100'>
              <h2 className='title-14 pt15 pb15 pr20 pl20'>1.1 Kết quả tìm kiếm</h2>
            </div>
            <div className='pl5 pr5'>
              <DataTableMultipleSelect onDisableCheck onCheck={this.handleSelectedAll.bind(this)} selectAllStatus={this.state.checkAll} header={header.thanhTra.KQTKTMDTTT2} dataList={this.state.ketQuaTimKiemList} tableLoading={this.state.tableLoading} pageData={this.state.pageData} parent={this}>
                <RowItemKetQuaTimKiemThanhTra />
              </DataTableMultipleSelect>
            </div>
            <div className='col-100 pb20 pt10 txt-center'>
              <Link className="btn-green" onClick={this.themVaoCuocTT.bind(this)}>
                <i className="tt tt-addfile"></i>{`Thêm vào cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}
              </Link>
            </div>
          </div>
          <div className='row pl10 pr10 '>
            <div className='row pl40 pr40'>
              <span className='line-border mt5 mb0'></span>
            </div>
            <div className='col-100'>
              <h2 className='title-14 pt15 pb15 pr20 pl20'>{`1.2 Danh sách đối tượng sẽ được thêm vào cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}</h2>
            </div>
            <div className='pl5 pr5'>
              <DataTable header={header.thanhTra.TMDTTT2} dataList={this.state.doiTuongSelectedList} hideButtonExport={true} hidePagination={true} parent={this} emptyMsg={`Chưa có đối tượng được thêm vào cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}>
                <RowItemDanhSachThemMoiThanhTra />
              </DataTable>
            </div>
          </div>
          <div className='row pl15 pr15'>
            <span className='line-border mt5 mb0'></span>
          </div>
          <div className="action-form-wrap pt20">
            <div className="box-bottom">
              <Link className="btn-action btn-close" onClick={this.closeDialog.bind(this, 'isOpen')}><span>Đóng</span></Link>
              <Link className="btn-action btn-save" onClick={this.handleSaveDoiTuongThanhTra.bind(this)}><span>Lưu</span></Link>
            </div>
          </div>
        </Dialog>
        <Dialog
          isOpen={this.state.isOpenThongBao}
          onClose={this.closeDialogThongBao.bind(this)}
          title={'Thông báo'}
          className="panel-popup category">
          <div className="pt-dialog-body">
            {`Danh sách đối tượng ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} vừa tải lên có `}
            <a className="txt-underline" download={this.state.fileName} href={`data:${this.state.mineType};base64,${this.state.base64Content}`}> {this.state.numberUnsuccess} </a>
            đối tượng chưa có trong hệ thống. Vui lòng bấm vào link Số đối tượng để tải xuống và kiểm tra lại
          </div>
          <div className="pt-dialog-footer">
            <Link onClick={this.closeDialogThongBao.bind(this)} className="btn-action btn-close" >
              <span>Đóng</span>
            </Link>
          </div>
        </Dialog>
      </div>
    );
  }
}

DialogChinhSuaCuocThanhTra.defaultProps = {
  data: {},
  hasXuLy: false
}

function bindStateToProps(state) {
  return {
    hasXuLy: state.dataCuocThanhTra.hasXuLy,
    totalDataDeXuat: state.dataCuocThanhTra.totalDataDeXuat,
    dataDXOld: state.dataCuocThanhTra.dataDXOld,
  };
}

export default connect(bindStateToProps)(validatable(DialogChinhSuaCuocThanhTra));



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/sub-view/DialogChinhSuaCuocThanhTra.jsx